/* 
 * 菜单管理模块
 */
// 获取导航菜单树
export function findNavTree() {
  const navTreeData = {
    "code": 200,
    "data": [{
        "children": [{
            "children": [],
            "url": "/",
            "id": "轮播图管理",
            "name": "轮播图管理"
          },
          {
            "children": [],
            "url": "/module/module",
            "id": "模块启用禁用",
            "name": "模块启用禁用"
          }
        ],
        "id": "首页",
        "name": "首页"
      },
      {
        "children": [{
            "children": [

            ],
            "id": "消防设施操作员",
            "name": "消防设施操作员"
          },
          {
            "children": [

            ],
            "id": "消防安全管理员",
            "name": "消防安全管理员"
          },
          {
            "children": [

            ],
            "id": "注册消防工程师",
            "name": "注册消防工程师"
          },
          {
            "children": [

            ],
            "id": "考试中心",
            "name": "考试中心"
          }
        ],
        "id": "题库管理",
        "name": "题库管理"
      },
      {
        "children": [{
            "children": [

            ],
            "id": "消防设施操作员",
            "name": "消防设施操作员"
          },
          {
            "children": [

            ],
            "id": "消防安全管理员",
            "name": "消防安全管理员"
          },
          {
            "children": [

            ],
            "id": "注册消防工程师",
            "name": "注册消防工程师"
          }
        ],
        "id": "视频管理",
        "name": "视频管理"
      },
      {
        "children": [{
            "children": [

            ],
            "id": "用户列表",
            "name": "用户列表"
          },
          {
            "children": [

            ],
            "id": "管理员列表",
            "name": "管理员列表"
          }
        ],
        "id": "用户管理",
        "name": "用户管理"
      },
      {
        "children": [{
            "children": [{
                "children": [

                ],
                "id": "消防设施操作员",
                "name": "消防设施操作员"
              },
              {
                "children": [

                ],
                "id": "消防安全管理员",
                "name": "消防安全管理员"
              },
              {
                "children": [

                ],
                "id": "注册消防工程师",
                "name": "注册消防工程师"
              }
            ],
            "id": "题库价格",
            "name": "题库价格"
          },
          {
            "children": [{
                "children": [

                ],
                "id": "消防设施操作员",
                "name": "消防设施操作员"
              },
              {
                "children": [

                ],
                "id": "消防安全管理员",
                "name": "消防安全管理员"
              },
              {
                "children": [

                ],
                "id": "注册消防工程师",
                "name": "注册消防工程师"
              }
            ],
            "id": "视频价格",
            "name": "视频价格"
          },
          {
            "children": [{
                "children": [

                ],
                "id": "1年会员",
                "name": "1年会员"
              },
              {
                "children": [

                ],
                "id": "3年会员",
                "name": "3年会员"
              },
              {
                "children": [

                ],
                "id": "永久会员",
                "name": "永久会员"
              }
            ],
            "id": "会员价格",
            "name": "会员价格"
          }
        ],
        "id": "价格管理",
        "name": "价格管理"
      }
    ],
    "msg": "成功"
  }
  // const navTreeData = {
  //   "code": 200,
  //   "msg": null,
  //   "data": [{
  //       "id": 100,
  //       "createBy": "admin",
  //       "createTime": "2018-12-27T03:05:48.000+0000",
  //       "lastUpdateBy": "admin",
  //       "lastUpdateTime": "2018-12-27T03:06:39.000+0000",
  //       "parentId": 0,
  //       "name": "首页",
  //       "url": "",
  //       "perms": "",
  //       "type": 0,
  //       "icon": "el-icon-service",
  //       "orderNum": 2,
  //       "delFlag": 0,
  //       "parentName": null,
  //       "level": 0,
  //       "children": [{
  //           "id": 101,
  //           "createBy": "admin",
  //           "createTime": "2018-11-03T03:06:48.000+0000",
  //           "lastUpdateBy": "admin",
  //           "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //           "parentId": 100,
  //           "name": "轮播图管理",
  //           "url": "/",
  //           "perms": "",
  //           "type": 1,
  //           "icon": " el-icon-view",
  //           "orderNum": 0,
  //           "delFlag": 0,
  //           "parentName": "首页",
  //           "level": 1,
  //           "children": []
  //         },
  //         {
  //           "id": 102,
  //           "createBy": "admin",
  //           "createTime": "2018-11-03T03:06:48.000+0000",
  //           "lastUpdateBy": "admin",
  //           "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //           "parentId": 100,
  //           "name": "模块启用禁用",
  //           "url": "/module/module",
  //           "perms": "",
  //           "type": 1,
  //           "icon": " el-icon-view",
  //           "orderNum": 0,
  //           "delFlag": 0,
  //           "parentName": "首页",
  //           "level": 1,
  //           "children": []
  //         }
  //       ]
  //     },
  //     {
  //       "id": 200,
  //       "createBy": "admin",
  //       "createTime": "2018-12-27T03:05:48.000+0000",
  //       "lastUpdateBy": "admin",
  //       "lastUpdateTime": "2018-12-27T03:06:39.000+0000",
  //       "parentId": 0,
  //       "name": "题库管理",
  //       "url": "",
  //       "perms": "",
  //       "type": 0,
  //       "icon": "el-icon-service",
  //       "orderNum": 2,
  //       "delFlag": 0,
  //       "parentName": null,
  //       "level": 0,
  //       "children": [{
  //           "id": 201,
  //           "createBy": "admin",
  //           "createTime": "2018-11-03T03:06:48.000+0000",
  //           "lastUpdateBy": "admin",
  //           "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //           "parentId": 200,
  //           "name": "消防设施操作员",
  //           "url": "/",
  //           "perms": "",
  //           "type": 1,
  //           "icon": " el-icon-view",
  //           "orderNum": 0,
  //           "delFlag": 0,
  //           "parentName": "题库管理",
  //           "level": 1,
  //           "children": [{
  //             "id": 211,
  //             "createBy": "admin",
  //             "createTime": "2018-11-03T03:06:48.000+0000",
  //             "lastUpdateBy": "admin",
  //             "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //             "parentId": 201,
  //             "name": "消防设施操作员初级监控方向",
  //             "url": "/",
  //             "perms": "",
  //             "type": 1,
  //             "icon": " el-icon-view",
  //             "orderNum": 0,
  //             "delFlag": 0,
  //             "parentName": "消防设施操作员",
  //             "level": 2,
  //             "children": [{
  //                 "id": 212,
  //                 "createBy": "admin",
  //                 "createTime": "2018-11-03T03:06:48.000+0000",
  //                 "lastUpdateBy": "admin",
  //                 "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                 "parentId": 211,
  //                 "name": "模拟考试",
  //                 "url": "/mockExam/mockExam",
  //                 "perms": "",
  //                 "type": 1,
  //                 "icon": " el-icon-view",
  //                 "orderNum": 0,
  //                 "delFlag": 0,
  //                 "parentName": "消防设施操作员初级监控方向",
  //                 "level": 3,
  //                 "children": []
  //               },
  //               {
  //                 "id": 231,
  //                 "createBy": "admin",
  //                 "createTime": "2018-11-03T03:06:48.000+0000",
  //                 "lastUpdateBy": "admin",
  //                 "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                 "parentId": 211,
  //                 "name": "题库",
  //                 "url": "/",
  //                 "perms": "",
  //                 "type": 1,
  //                 "icon": " el-icon-view",
  //                 "orderNum": 0,
  //                 "delFlag": 0,
  //                 "parentName": "消防设施操作员初级监控方向",
  //                 "level": 3,
  //                 "children": [{
  //                     "id": 241,
  //                     "createBy": "admin",
  //                     "createTime": "2018-11-03T03:06:48.000+0000",
  //                     "lastUpdateBy": "admin",
  //                     "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                     "parentId": 231,
  //                     "name": "基础知识",
  //                     "url": "/",
  //                     "perms": "",
  //                     "type": 1,
  //                     "icon": " el-icon-view",
  //                     "orderNum": 0,
  //                     "delFlag": 0,
  //                     "parentName": "题库",
  //                     "level": 4,
  //                     "children": []
  //                   },
  //                   {
  //                     "id": 242,
  //                     "createBy": "admin",
  //                     "createTime": "2018-11-03T03:06:48.000+0000",
  //                     "lastUpdateBy": "admin",
  //                     "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                     "parentId": 231,
  //                     "name": "实操",
  //                     "url": "/",
  //                     "perms": "",
  //                     "type": 1,
  //                     "icon": " el-icon-view",
  //                     "orderNum": 0,
  //                     "delFlag": 0,
  //                     "parentName": "题库",
  //                     "level": 4,
  //                     "children": []
  //                   }
  //                 ]
  //               },
  //               {
  //                 "id": 213,
  //                 "createBy": "admin",
  //                 "createTime": "2018-11-03T03:06:48.000+0000",
  //                 "lastUpdateBy": "admin",
  //                 "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                 "parentId": 211,
  //                 "name": "章节练习",
  //                 "url": "/",
  //                 "perms": "",
  //                 "type": 1,
  //                 "icon": " el-icon-view",
  //                 "orderNum": 0,
  //                 "delFlag": 0,
  //                 "parentName": "消防设施操作员初级监控方向",
  //                 "level": 3,
  //                 "children": []
  //               },
  //               {
  //                 "id": 214,
  //                 "createBy": "admin",
  //                 "createTime": "2018-11-03T03:06:48.000+0000",
  //                 "lastUpdateBy": "admin",
  //                 "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                 "parentId": 211,
  //                 "name": "考前冲刺",
  //                 "url": "/",
  //                 "perms": "",
  //                 "type": 1,
  //                 "icon": " el-icon-view",
  //                 "orderNum": 0,
  //                 "delFlag": 0,
  //                 "parentName": "消防设施操作员初级监控方向",
  //                 "level": 3,
  //                 "children": [
  //                   {
  //                     "id": 2114,
  //                     "createBy": "admin",
  //                     "createTime": "2018-11-03T03:06:48.000+0000",
  //                     "lastUpdateBy": "admin",
  //                     "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                     "parentId": 214,
  //                     "name": "考前刷题",
  //                     "url": "/preExam/brushQuestions",
  //                     "perms": "",
  //                     "type": 1,
  //                     "icon": " el-icon-view",
  //                     "orderNum": 0,
  //                     "delFlag": 0,
  //                     "parentName": "考前冲刺",
  //                     "level": 3,
  //                     "children": []
  //                   },
  //                   {
  //                     "id": 2115,
  //                     "createBy": "admin",
  //                     "createTime": "2018-11-03T03:06:48.000+0000",
  //                     "lastUpdateBy": "admin",
  //                     "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                     "parentId": 214,
  //                     "name": "考前知识点",
  //                     "url": "/preExam/knowledgePoints",
  //                     "perms": "",
  //                     "type": 1,
  //                     "icon": " el-icon-view",
  //                     "orderNum": 0,
  //                     "delFlag": 0,
  //                     "parentName": "考前冲刺",
  //                     "level": 3,
  //                     "children": []
  //                   }
  //                 ]
  //               },
  //               {
  //                 "id": 215,
  //                 "createBy": "admin",
  //                 "createTime": "2018-11-03T03:06:48.000+0000",
  //                 "lastUpdateBy": "admin",
  //                 "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                 "parentId": 211,
  //                 "name": "历年真题",
  //                 "url": "/historyTrueExam/historyTrueExam",
  //                 "perms": "",
  //                 "type": 1,
  //                 "icon": " el-icon-view",
  //                 "orderNum": 0,
  //                 "delFlag": 0,
  //                 "parentName": "消防设施操作员初级监控方向",
  //                 "level": 3,
  //                 "children": []
  //               }
  //             ]
  //           }]
  //         },
  //         {
  //           "id": 2002,
  //           "createBy": "admin",
  //           "createTime": "2018-11-03T03:06:48.000+0000",
  //           "lastUpdateBy": "admin",
  //           "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //           "parentId": 200,
  //           "name": "消防安全管理员",
  //           "url": "/module/module",
  //           "perms": "",
  //           "type": 1,
  //           "icon": "el-icon-view",
  //           "orderNum": 0,
  //           "delFlag": 0,
  //           "parentName": "题库管理",
  //           "level": 1,
  //           "children": [{
  //               "id": 2003,
  //               "createBy": "admin",
  //               "createTime": "2018-12-27T03:08:11.000+0000",
  //               "lastUpdateBy": "admin",
  //               "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //               "parentId": 2002,
  //               "name": "初级",
  //               "url": "/module/primary",
  //               "perms": "",
  //               "type": 1,
  //               "icon": "el-icon-view",
  //               "orderNum": 1,
  //               "delFlag": 0,
  //               "parentName": "消防安全管理员",
  //               "level": 2,
  //               "children": [{
  //                   "id": 2004,
  //                   "createBy": "admin",
  //                   "createTime": "2018-12-27T03:08:11.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 2003,
  //                   "name": "模拟考试",
  //                   "url": "/mockExam/mockExam",
  //                   "perms": "",
  //                   "type": 1,
  //                   "icon": "el-icon-view",
  //                   "orderNum": 1,
  //                   "delFlag": 0,
  //                   "parentName": "初级",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 2005,
  //                   "createBy": "admin",
  //                   "createTime": "2018-12-27T03:08:11.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 2003,
  //                   "name": "题库",
  //                   "url": "/module/primary/questionbank",
  //                   "perms": "",
  //                   "type": 1,
  //                   "icon": "el-icon-view",
  //                   "orderNum": 2,
  //                   "delFlag": 0,
  //                   "parentName": "初级",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 2006,
  //                   "createBy": "admin",
  //                   "createTime": "2018-12-27T03:08:11.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 2003,
  //                   "name": "章节练习",
  //                   "url": "/module/primary/chapter",
  //                   "perms": "",
  //                   "type": 1,
  //                   "icon": "el-icon-view",
  //                   "orderNum": 3,
  //                   "delFlag": 0,
  //                   "parentName": "初级",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 2007,
  //                   "createBy": "admin",
  //                   "createTime": "2018-12-27T03:08:11.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 2003,
  //                   "name": "考前冲刺",
  //                   "url": "/module/primary/pre-exam",
  //                   "perms": "",
  //                   "type": 1,
  //                   "icon": "el-icon-view",
  //                   "orderNum": 4,
  //                   "delFlag": 0,
  //                   "parentName": "初级",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 2008,
  //                   "createBy": "admin",
  //                   "createTime": "2018-12-27T03:08:11.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 2003,
  //                   "name": "历年真题",
  //                   "url": "/historyTrueExam/historyTrueExam",
  //                   "perms": "",
  //                   "type": 1,
  //                   "icon": "el-icon-view",
  //                   "orderNum": 5,
  //                   "delFlag": 0,
  //                   "parentName": "初级",
  //                   "level": 3
  //                 }
  //               ]
  //             },
  //             {
  //               "id": 2009,
  //               "createBy": "admin",
  //               "createTime": "2018-12-27T03:08:11.000+0000",
  //               "lastUpdateBy": "admin",
  //               "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //               "parentId": 2002,
  //               "name": "中级",
  //               "url": "/module/intermediate",
  //               "perms": "",
  //               "type": 1,
  //               "icon": "el-icon-view",
  //               "orderNum": 2,
  //               "delFlag": 0,
  //               "parentName": "消防安全管理员",
  //               "level": 2,
  //               "children": [{
  //                   "id": 2010,
  //                   "createBy": "admin",
  //                   "createTime": "2018-12-27T03:08:11.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 2009,
  //                   "name": "模拟考试",
  //                   "url": "/mockExam/mockExam",
  //                   "perms": "",
  //                   "type": 1,
  //                   "icon": "el-icon-view",
  //                   "orderNum": 1,
  //                   "delFlag": 0,
  //                   "parentName": "中级",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 2011,
  //                   "createBy": "admin",
  //                   "createTime": "2018-12-27T03:08:11.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 2009,
  //                   "name": "题库",
  //                   "url": "/module/intermediate/questionbank",
  //                   "perms": "",
  //                   "type": 1,
  //                   "icon": "el-icon-view",
  //                   "orderNum": 2,
  //                   "delFlag": 0,
  //                   "parentName": "中级",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 2012,
  //                   "createBy": "admin",
  //                   "createTime": "2018-12-27T03:08:11.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 2009,
  //                   "name": "章节练习",
  //                   "url": "/module/intermediate/chapter",
  //                   "perms": "",
  //                   "type": 1,
  //                   "icon": "el-icon-view",
  //                   "orderNum": 3,
  //                   "delFlag": 0,
  //                   "parentName": "中级",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 2013,
  //                   "createBy": "admin",
  //                   "createTime": "2018-12-27T03:08:11.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 2009,
  //                   "name": "考前冲刺",
  //                   "url": "/module/intermediate/pre-exam",
  //                   "perms": "",
  //                   "type": 1,
  //                   "icon": "el-icon-view",
  //                   "orderNum": 4,
  //                   "delFlag": 0,
  //                   "parentName": "中级",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 2014,
  //                   "createBy": "admin",
  //                   "createTime": "2018-12-27T03:08:11.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 2009,
  //                   "name": "历年真题",
  //                   "url": "/historyTrueExam/historyTrueExam",
  //                   "perms": "",
  //                   "type": 1,
  //                   "icon": "el-icon-view",
  //                   "orderNum": 5,
  //                   "delFlag": 0,
  //                   "parentName": "中级",
  //                   "level": 3
  //                 }
  //               ]
  //             },
  //             {
  //               "id": 2015,
  //               "createBy": "admin",
  //               "createTime": "2018-12-27T03:08:11.000+0000",
  //               "lastUpdateBy": "admin",
  //               "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //               "parentId": 2002,
  //               "name": "高级",
  //               "url": "/module/advanced",
  //               "perms": "",
  //               "type": 1,
  //               "icon": "el-icon-view",
  //               "orderNum": 3,
  //               "delFlag": 0,
  //               "parentName": "消防安全管理员",
  //               "level": 2,
  //               "children": [{
  //                   "id": 2016,
  //                   "createBy": "admin",
  //                   "createTime": "2018-12-27T03:08:11.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 2015,
  //                   "name": "模拟考试",
  //                   "url": "/mockExam/mockExam",
  //                   "perms": "",
  //                   "type": 1,
  //                   "icon": "el-icon-view",
  //                   "orderNum": 1,
  //                   "delFlag": 0,
  //                   "parentName": "高级",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 2017,
  //                   "createBy": "admin",
  //                   "createTime": "2018-12-27T03:08:11.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 2015,
  //                   "name": "题库",
  //                   "url": "/module/advanced/questionbank",
  //                   "perms": "",
  //                   "type": 1,
  //                   "icon": "el-icon-view",
  //                   "orderNum": 2,
  //                   "delFlag": 0,
  //                   "parentName": "高级",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 2018,
  //                   "createBy": "admin",
  //                   "createTime": "2018-12-27T03:08:11.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 2015,
  //                   "name": "章节练习",
  //                   "url": "/module/advanced/chapter",
  //                   "perms": "",
  //                   "type": 1,
  //                   "icon": "el-icon-view",
  //                   "orderNum": 3,
  //                   "delFlag": 0,
  //                   "parentName": "高级",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 2019,
  //                   "createBy": "admin",
  //                   "createTime": "2018-12-27T03:08:11.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 2015,
  //                   "name": "考前冲刺",
  //                   "url": "/module/advanced/pre-exam",
  //                   "perms": "",
  //                   "type": 1,
  //                   "icon": "el-icon-view",
  //                   "orderNum": 4,
  //                   "delFlag": 0,
  //                   "parentName": "高级",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 2020,
  //                   "createBy": "admin",
  //                   "createTime": "2018-12-27T03:08:11.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 2015,
  //                   "name": "历年真题",
  //                   "url": "/historyTrueExam/historyTrueExam",
  //                   "perms": "",
  //                   "type": 1,
  //                   "icon": "el-icon-view",
  //                   "orderNum": 5,
  //                   "delFlag": 0,
  //                   "parentName": "高级",
  //                   "level": 3
  //                 }
  //               ]
  //             }
  //           ]
  //         },
  //         {
  //           "id": 3000,
  //           "createBy": "admin",
  //           "createTime": "2018-11-03T03:06:48.000+0000",
  //           "lastUpdateBy": "admin",
  //           "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //           "parentId": 200,
  //           "name": "注册消防工程师",
  //           "url": "/module/module",
  //           "perms": "",
  //           "type": 1,
  //           "icon": "el-icon-view",
  //           "orderNum": 0,
  //           "delFlag": 0,
  //           "parentName": "题库管理",
  //           "level": 1,
  //           "children": [{
  //               "id": 3001,
  //               "createBy": "admin",
  //               "createTime": "2018-11-03T03:06:48.000+0000",
  //               "lastUpdateBy": "admin",
  //               "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //               "parentId": 3000,
  //               "name": "一级消防工程师",
  //               "url": "/module/level1",
  //               "perms": "",
  //               "type": 2,
  //               "icon": "el-icon-s-flag",
  //               "orderNum": 1,
  //               "delFlag": 0,
  //               "parentName": "注册消防工程师",
  //               "level": 2,
  //               "children": [{
  //                   "id": 3002,
  //                   "createBy": "admin",
  //                   "createTime": "2018-11-03T03:06:48.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 3001,
  //                   "name": "技术实务",
  //                   "url": "/module/level1/technical",
  //                   "perms": "",
  //                   "type": 3,
  //                   "icon": "el-icon-s-tools",
  //                   "orderNum": 1,
  //                   "delFlag": 0,
  //                   "parentName": "一级消防工程师",
  //                   "level": 3,
  //                   "children": [{
  //                       "id": 3003,
  //                       "createBy": "admin",
  //                       "createTime": "2018-11-03T03:06:48.000+0000",
  //                       "lastUpdateBy": "admin",
  //                       "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                       "parentId": 3002,
  //                       "name": "考点练习",
  //                       "url": "/module/level1/technical/exam-points",
  //                       "perms": "",
  //                       "type": 4,
  //                       "icon": "el-icon-notebook-2",
  //                       "orderNum": 1,
  //                       "delFlag": 0,
  //                       "parentName": "技术实务",
  //                       "level": 4
  //                     },
  //                     {
  //                       "id": 3004,
  //                       "createBy": "admin",
  //                       "createTime": "2018-11-03T03:06:48.000+0000",
  //                       "lastUpdateBy": "admin",
  //                       "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                       "parentId": 3002,
  //                       "name": "历年真题",
  //                       "url": "/historyTrueExam/historyTrueExam",
  //                       "perms": "",
  //                       "type": 4,
  //                       "icon": "el-icon-notebook-2",
  //                       "orderNum": 2,
  //                       "delFlag": 0,
  //                       "parentName": "技术实务",
  //                       "level": 4
  //                     },
  //                     {
  //                       "id": 30041,
  //                       "createBy": "admin",
  //                       "createTime": "2018-11-03T03:06:48.000+0000",
  //                       "lastUpdateBy": "admin",
  //                       "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                       "parentId": 3002,
  //                       "name": "高频题库",
  //                       "url": "/module/level1/technical/past-papers",
  //                       "perms": "",
  //                       "type": 4,
  //                       "icon": "el-icon-notebook-2",
  //                       "orderNum": 2,
  //                       "delFlag": 0,
  //                       "parentName": "技术实务",
  //                       "level": 4
  //                     },
  //                     {
  //                       "id": 30042,
  //                       "createBy": "admin",
  //                       "createTime": "2018-11-03T03:06:48.000+0000",
  //                       "lastUpdateBy": "admin",
  //                       "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                       "parentId": 3002,
  //                       "name": "章节练习",
  //                       "url": "/module/level1/technical/past-papers",
  //                       "perms": "",
  //                       "type": 4,
  //                       "icon": "el-icon-notebook-2",
  //                       "orderNum": 2,
  //                       "delFlag": 0,
  //                       "parentName": "技术实务",
  //                       "level": 4
  //                     },
  //                     {
  //                       "id": 30043,
  //                       "createBy": "admin",
  //                       "createTime": "2018-11-03T03:06:48.000+0000",
  //                       "lastUpdateBy": "admin",
  //                       "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                       "parentId": 3002,
  //                       "name": "模拟测试",
  //                       "url": "/module/level1/technical/past-papers",
  //                       "perms": "",
  //                       "type": 4,
  //                       "icon": "el-icon-notebook-2",
  //                       "orderNum": 2,
  //                       "delFlag": 0,
  //                       "parentName": "技术实务",
  //                       "level": 4
  //                     },
  //                     {
  //                       "id": 30044,
  //                       "createBy": "admin",
  //                       "createTime": "2018-11-03T03:06:48.000+0000",
  //                       "lastUpdateBy": "admin",
  //                       "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                       "parentId": 3002,
  //                       "name": "冲刺练习",
  //                       "url": "/module/level1/technical/past-papers",
  //                       "perms": "",
  //                       "type": 4,
  //                       "icon": "el-icon-notebook-2",
  //                       "orderNum": 2,
  //                       "delFlag": 0,
  //                       "parentName": "技术实务",
  //                       "level": 4
  //                     },
  //                     // ... 其他子菜单项
  //                   ]
  //                 },
  //                 {
  //                   "id": 3005,
  //                   "createBy": "admin",
  //                   "createTime": "2018-11-03T03:06:48.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 3001,
  //                   "name": "综合能力",
  //                   "url": "/module/level1/overall",
  //                   "perms": "",
  //                   "type": 3,
  //                   "icon": "el-icon-s-data",
  //                   "orderNum": 2,
  //                   "delFlag": 0,
  //                   "parentName": "一级消防工程师",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 3006,
  //                   "createBy": "admin",
  //                   "createTime": "2018-11-03T03:06:48.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 3001,
  //                   "name": "案例分析",
  //                   "url": "/module/level1/overall",
  //                   "perms": "",
  //                   "type": 3,
  //                   "icon": "el-icon-s-data",
  //                   "orderNum": 2,
  //                   "delFlag": 0,
  //                   "parentName": "一级消防工程师",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 3007,
  //                   "createBy": "admin",
  //                   "createTime": "2018-11-03T03:06:48.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 3001,
  //                   "name": "报考指南",
  //                   "url": "/module/level1/overall",
  //                   "perms": "",
  //                   "type": 3,
  //                   "icon": "el-icon-s-data",
  //                   "orderNum": 2,
  //                   "delFlag": 0,
  //                   "parentName": "一级消防工程师",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 3008,
  //                   "createBy": "admin",
  //                   "createTime": "2018-11-03T03:06:48.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 3001,
  //                   "name": "备考复习计划",
  //                   "url": "/module/level1/overall",
  //                   "perms": "",
  //                   "type": 3,
  //                   "icon": "el-icon-s-data",
  //                   "orderNum": 2,
  //                   "delFlag": 0,
  //                   "parentName": "一级消防工程师",
  //                   "level": 3
  //                 },
  //                 {
  //                   "id": 3009,
  //                   "createBy": "admin",
  //                   "createTime": "2018-11-03T03:06:48.000+0000",
  //                   "lastUpdateBy": "admin",
  //                   "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                   "parentId": 3001,
  //                   "name": "相关规范",
  //                   "url": "/module/level1/overall",
  //                   "perms": "",
  //                   "type": 3,
  //                   "icon": "el-icon-s-data",
  //                   "orderNum": 2,
  //                   "delFlag": 0,
  //                   "parentName": "一级消防工程师",
  //                   "level": 3
  //                 },
  //                 // ... 其他子菜单项
  //               ]
  //             },
  //             {
  //               "id": 3006,
  //               "createBy": "admin",
  //               "createTime": "2018-11-03T03:06:48.000+0000",
  //               "lastUpdateBy": "admin",
  //               "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //               "parentId": 3000,
  //               "name": "二级消防工程师",
  //               "url": "/module/level2",
  //               "perms": "",
  //               "type": 2,
  //               "icon": "el-icon-s-flag",
  //               "orderNum": 2,
  //               "delFlag": 0,
  //               "parentName": "注册消防工程师",
  //               "level": 2,
  //               "children": [{
  //                 "id": 3002,
  //                 "createBy": "admin",
  //                 "createTime": "2018-11-03T03:06:48.000+0000",
  //                 "lastUpdateBy": "admin",
  //                 "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                 "parentId": 3001,
  //                 "name": "技术实务",
  //                 "url": "/module/level1/technical",
  //                 "perms": "",
  //                 "type": 3,
  //                 "icon": "el-icon-s-tools",
  //                 "orderNum": 1,
  //                 "delFlag": 0,
  //                 "parentName": "二级消防工程师",
  //                 "level": 3,
  //                 "children": [{
  //                     "id": 3003,
  //                     "createBy": "admin",
  //                     "createTime": "2018-11-03T03:06:48.000+0000",
  //                     "lastUpdateBy": "admin",
  //                     "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                     "parentId": 3002,
  //                     "name": "考点练习",
  //                     "url": "/module/level1/technical/exam-points",
  //                     "perms": "",
  //                     "type": 4,
  //                     "icon": "el-icon-notebook-2",
  //                     "orderNum": 1,
  //                     "delFlag": 0,
  //                     "parentName": "技术实务",
  //                     "level": 4
  //                   },
  //                   {
  //                     "id": 3004,
  //                     "createBy": "admin",
  //                     "createTime": "2018-11-03T03:06:48.000+0000",
  //                     "lastUpdateBy": "admin",
  //                     "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                     "parentId": 3002,
  //                     "name": "历年真题",
  //                     "url": "/historyTrueExam/historyTrueExam",
  //                     "perms": "",
  //                     "type": 4,
  //                     "icon": "el-icon-notebook-2",
  //                     "orderNum": 2,
  //                     "delFlag": 0,
  //                     "parentName": "技术实务",
  //                     "level": 4
  //                   },
  //                   {
  //                     "id": 30041,
  //                     "createBy": "admin",
  //                     "createTime": "2018-11-03T03:06:48.000+0000",
  //                     "lastUpdateBy": "admin",
  //                     "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                     "parentId": 3002,
  //                     "name": "高频题库",
  //                     "url": "/module/level1/technical/past-papers",
  //                     "perms": "",
  //                     "type": 4,
  //                     "icon": "el-icon-notebook-2",
  //                     "orderNum": 2,
  //                     "delFlag": 0,
  //                     "parentName": "技术实务",
  //                     "level": 4
  //                   },
  //                   {
  //                     "id": 30042,
  //                     "createBy": "admin",
  //                     "createTime": "2018-11-03T03:06:48.000+0000",
  //                     "lastUpdateBy": "admin",
  //                     "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                     "parentId": 3002,
  //                     "name": "章节练习",
  //                     "url": "/module/level1/technical/past-papers",
  //                     "perms": "",
  //                     "type": 4,
  //                     "icon": "el-icon-notebook-2",
  //                     "orderNum": 2,
  //                     "delFlag": 0,
  //                     "parentName": "技术实务",
  //                     "level": 4
  //                   },
  //                   {
  //                     "id": 30043,
  //                     "createBy": "admin",
  //                     "createTime": "2018-11-03T03:06:48.000+0000",
  //                     "lastUpdateBy": "admin",
  //                     "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                     "parentId": 3002,
  //                     "name": "模拟测试",
  //                     "url": "/module/level1/technical/past-papers",
  //                     "perms": "",
  //                     "type": 4,
  //                     "icon": "el-icon-notebook-2",
  //                     "orderNum": 2,
  //                     "delFlag": 0,
  //                     "parentName": "技术实务",
  //                     "level": 4
  //                   },
  //                   {
  //                     "id": 30044,
  //                     "createBy": "admin",
  //                     "createTime": "2018-11-03T03:06:48.000+0000",
  //                     "lastUpdateBy": "admin",
  //                     "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                     "parentId": 3002,
  //                     "name": "冲刺练习",
  //                     "url": "/module/level1/technical/past-papers",
  //                     "perms": "",
  //                     "type": 4,
  //                     "icon": "el-icon-notebook-2",
  //                     "orderNum": 2,
  //                     "delFlag": 0,
  //                     "parentName": "技术实务",
  //                     "level": 4
  //                   },
  //                   // ... 其他子菜单项
  //                 ]
  //               },
  //               {
  //                 "id": 3005,
  //                 "createBy": "admin",
  //                 "createTime": "2018-11-03T03:06:48.000+0000",
  //                 "lastUpdateBy": "admin",
  //                 "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                 "parentId": 3001,
  //                 "name": "综合能力",
  //                 "url": "/module/level1/overall",
  //                 "perms": "",
  //                 "type": 3,
  //                 "icon": "el-icon-s-data",
  //                 "orderNum": 2,
  //                 "delFlag": 0,
  //                 "parentName": "二级消防工程师",
  //                 "level": 3
  //               },
  //               {
  //                 "id": 3006,
  //                 "createBy": "admin",
  //                 "createTime": "2018-11-03T03:06:48.000+0000",
  //                 "lastUpdateBy": "admin",
  //                 "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                 "parentId": 3001,
  //                 "name": "案例分析",
  //                 "url": "/module/level1/overall",
  //                 "perms": "",
  //                 "type": 3,
  //                 "icon": "el-icon-s-data",
  //                 "orderNum": 2,
  //                 "delFlag": 0,
  //                 "parentName": "二级消防工程师",
  //                 "level": 3
  //               },
  //               {
  //                 "id": 3007,
  //                 "createBy": "admin",
  //                 "createTime": "2018-11-03T03:06:48.000+0000",
  //                 "lastUpdateBy": "admin",
  //                 "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                 "parentId": 3001,
  //                 "name": "报考指南",
  //                 "url": "/module/level1/overall",
  //                 "perms": "",
  //                 "type": 3,
  //                 "icon": "el-icon-s-data",
  //                 "orderNum": 2,
  //                 "delFlag": 0,
  //                 "parentName": "二级消防工程师",
  //                 "level": 3
  //               },
  //               {
  //                 "id": 3008,
  //                 "createBy": "admin",
  //                 "createTime": "2018-11-03T03:06:48.000+0000",
  //                 "lastUpdateBy": "admin",
  //                 "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                 "parentId": 3001,
  //                 "name": "备考复习计划",
  //                 "url": "/module/level1/overall",
  //                 "perms": "",
  //                 "type": 3,
  //                 "icon": "el-icon-s-data",
  //                 "orderNum": 2,
  //                 "delFlag": 0,
  //                 "parentName": "二级消防工程师",
  //                 "level": 3
  //               },
  //               {
  //                 "id": 3009,
  //                 "createBy": "admin",
  //                 "createTime": "2018-11-03T03:06:48.000+0000",
  //                 "lastUpdateBy": "admin",
  //                 "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //                 "parentId": 3001,
  //                 "name": "相关规范",
  //                 "url": "/module/level1/overall",
  //                 "perms": "",
  //                 "type": 3,
  //                 "icon": "el-icon-s-data",
  //                 "orderNum": 2,
  //                 "delFlag": 0,
  //                 "parentName": "二级消防工程师",
  //                 "level": 3
  //               },
  //               // ... 其他子菜单项
  //             ]
  //             }
  //             // ... 其他子菜单项
  //           ]
  //         },
  //         {
  //           "id": 204,
  //           "createBy": "admin",
  //           "createTime": "2018-11-03T03:06:48.000+0000",
  //           "lastUpdateBy": "admin",
  //           "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //           "parentId": 200,
  //           "name": "考试中心",
  //           "url": "/module/module",
  //           "perms": "",
  //           "type": 1,
  //           "icon": " el-icon-view",
  //           "orderNum": 0,
  //           "delFlag": 0,
  //           "parentName": "题库管理",
  //           "level": 1,
  //           "children": []
  //         }
  //       ]
  //     },
  //     {
  //       "id": 1000,
  //       "createBy": "admin",
  //       "createTime": "2018-12-27T02:57:29.000+0000",
  //       "lastUpdateBy": "admin",
  //       "lastUpdateTime": "2018-12-27T03:02:26.000+0000",
  //       "parentId": 0,
  //       "name": "用户管理",
  //       "url": "",
  //       "perms": "",
  //       "type": 0,
  //       "icon": "el-icon-info",
  //       "orderNum": 1,
  //       "delFlag": 0,
  //       "parentName": null,
  //       "level": 0,
  //       "children": [{
  //         "id": 1001,
  //         "createBy": "admin",
  //         "createTime": "2018-12-27T02:57:29.000+0000",
  //         "lastUpdateBy": "admin",
  //         "lastUpdateTime": "2018-12-27T03:02:26.000+0000",
  //         "parentId": 1000,
  //         "name": "用户列表",
  //         "url": "/userManage/user",
  //         "perms": "",
  //         "type": 0,
  //         "icon": "el-icon-info",
  //         "orderNum": 1,
  //         "delFlag": 0,
  //         "parentName": "用户管理",
  //         "level": 0,
  //         "children": []
  //       }, {
  //         "id": 1002,
  //         "createBy": "admin",
  //         "createTime": "2018-12-27T02:57:29.000+0000",
  //         "lastUpdateBy": "admin",
  //         "lastUpdateTime": "2018-12-27T03:02:26.000+0000",
  //         "parentId": 1000,
  //         "name": "管理员列表",
  //         "url": "/userManage/admin",
  //         "perms": "",
  //         "type": 0,
  //         "icon": "el-icon-info",
  //         "orderNum": 1,
  //         "delFlag": 0,
  //         "parentName": "用户管理",
  //         "level": 0,
  //         "children": []
  //       }]
  //     },{
  //       "id": 9000,
  //       "createBy": "admin",
  //       "createTime": "2018-12-27T02:57:29.000+0000",
  //       "lastUpdateBy": "admin",
  //       "lastUpdateTime": "2018-12-27T03:02:26.000+0000",
  //       "parentId": 0,
  //       "name": "考试中心",
  //       "url": "/examCenter/examCenter",
  //       "perms": "",
  //       "type": 0,
  //       "icon": "el-icon-info",
  //       "orderNum": 1,
  //       "delFlag": 0,
  //       "parentName": null,
  //       "level": 0,
  //       "children": []
  //     },
  //     {
  //       "id": 1,
  //       "createBy": null,
  //       "createTime": null,
  //       "lastUpdateBy": null,
  //       "lastUpdateTime": null,
  //       "parentId": 0,
  //       "name": "系统管理",
  //       "url": null,
  //       "perms": null,
  //       "type": 0,
  //       "icon": "el-icon-setting",
  //       "orderNum": 0,
  //       "delFlag": 0,
  //       "parentName": null,
  //       "level": 0,
  //       "children": [{
  //         "id": 2,
  //         "createBy": null,
  //         "createTime": null,
  //         "lastUpdateBy": null,
  //         "lastUpdateTime": null,
  //         "parentId": 1,
  //         "name": "用户管理",
  //         "url": "/sys/user",
  //         "perms": null,
  //         "type": 1,
  //         "icon": "el-icon-service",
  //         "orderNum": 1,
  //         "delFlag": 0,
  //         "parentName": "系统管理",
  //         "level": 1,
  //         "children": []
  //       }, {
  //         "id": 3,
  //         "createBy": null,
  //         "createTime": null,
  //         "lastUpdateBy": null,
  //         "lastUpdateTime": null,
  //         "parentId": 1,
  //         "name": "机构管理",
  //         "url": "/sys/dept",
  //         "perms": null,
  //         "type": 1,
  //         "icon": "el-icon-news",
  //         "orderNum": 2,
  //         "delFlag": 0,
  //         "parentName": "系统管理",
  //         "level": 1,
  //         "children": []
  //       }, {
  //         "id": 4,
  //         "createBy": null,
  //         "createTime": null,
  //         "lastUpdateBy": null,
  //         "lastUpdateTime": null,
  //         "parentId": 1,
  //         "name": "角色管理",
  //         "url": "/sys/role",
  //         "perms": null,
  //         "type": 1,
  //         "icon": "el-icon-view",
  //         "orderNum": 4,
  //         "delFlag": 0,
  //         "parentName": "系统管理",
  //         "level": 1,
  //         "children": []
  //       }, {
  //         "id": 5,
  //         "createBy": null,
  //         "createTime": null,
  //         "lastUpdateBy": null,
  //         "lastUpdateTime": null,
  //         "parentId": 1,
  //         "name": "菜单管理",
  //         "url": "/sys/menu",
  //         "perms": null,
  //         "type": 1,
  //         "icon": "el-icon-menu",
  //         "orderNum": 5,
  //         "delFlag": 0,
  //         "parentName": "系统管理",
  //         "level": 1,
  //         "children": []
  //       }, {
  //         "id": 7,
  //         "createBy": null,
  //         "createTime": null,
  //         "lastUpdateBy": null,
  //         "lastUpdateTime": null,
  //         "parentId": 1,
  //         "name": "字典管理",
  //         "url": "/sys/dict",
  //         "perms": null,
  //         "type": 1,
  //         "icon": "el-icon-edit-outline",
  //         "orderNum": 7,
  //         "delFlag": 0,
  //         "parentName": "系统管理",
  //         "level": 1,
  //         "children": []
  //       }, {
  //         "id": 8,
  //         "createBy": null,
  //         "createTime": null,
  //         "lastUpdateBy": "admin",
  //         "lastUpdateTime": "2018-09-23T11:32:28.000+0000",
  //         "parentId": 1,
  //         "name": "系统日志",
  //         "url": "/sys/log",
  //         "perms": "sys:log:view",
  //         "type": 1,
  //         "icon": "el-icon-info",
  //         "orderNum": 8,
  //         "delFlag": 0,
  //         "parentName": "系统管理",
  //         "level": 1,
  //         "children": []
  //       }, {
  //         "id": 9,
  //         "createBy": null,
  //         "createTime": null,
  //         "lastUpdateBy": "admin",
  //         "lastUpdateTime": "2018-09-23T11:32:28.000+0000",
  //         "parentId": 1,
  //         "name": "打印测试",
  //         "url": "/sys/print",
  //         "perms": "sys:log:view",
  //         "type": 1,
  //         "icon": "el-icon-info",
  //         "orderNum": 9,
  //         "delFlag": 0,
  //         "parentName": "系统管理",
  //         "level": 1,
  //         "children": []
  //       }]
  //     },
  //     // {
  //     //   "id": 43,
  //     //   "createBy": "admin",
  //     //   "createTime": "2018-12-27T02:57:29.000+0000",
  //     //   "lastUpdateBy": "admin",
  //     //   "lastUpdateTime": "2018-12-27T03:02:26.000+0000",
  //     //   "parentId": 0,
  //     //   "name": "系统监控",
  //     //   "url": "",
  //     //   "perms": "",
  //     //   "type": 0,
  //     //   "icon": "el-icon-info",
  //     //   "orderNum": 1,
  //     //   "delFlag": 0,
  //     //   "parentName": null,
  //     //   "level": 0,
  //     //   "children": [{
  //     //     "id": 6,
  //     //     "createBy": null,
  //     //     "createTime": null,
  //     //     "lastUpdateBy": "admin",
  //     //     "lastUpdateTime": "2018-12-27T03:03:45.000+0000",
  //     //     "parentId": 43,
  //     //     "name": "数据监控",
  //     //     "url": "http://139.196.87.48:8001/druid/login.html",
  //     //     "perms": null,
  //     //     "type": 1,
  //     //     "icon": "el-icon-warning",
  //     //     "orderNum": 0,
  //     //     "delFlag": 0,
  //     //     "parentName": "系统监控",
  //     //     "level": 1,
  //     //     "children": []
  //     //   }, {
  //     //     "id": 38,
  //     //     "createBy": "admin",
  //     //     "createTime": "2018-11-02T12:02:15.000+0000",
  //     //     "lastUpdateBy": "admin",
  //     //     "lastUpdateTime": "2018-12-27T03:03:53.000+0000",
  //     //     "parentId": 43,
  //     //     "name": "服务监控",
  //     //     "url": "http://139.196.87.48:8000/",
  //     //     "perms": "",
  //     //     "type": 1,
  //     //     "icon": "el-icon-view",
  //     //     "orderNum": 1,
  //     //     "delFlag": 0,
  //     //     "parentName": "系统监控",
  //     //     "level": 1,
  //     //     "children": []
  //     //   }]
  //     // }, {
  //     //   "id": 44,
  //     //   "createBy": "admin",
  //     //   "createTime": "2018-12-27T03:05:48.000+0000",
  //     //   "lastUpdateBy": "admin",
  //     //   "lastUpdateTime": "2018-12-27T03:06:39.000+0000",
  //     //   "parentId": 0,
  //     //   "name": "服务治理",
  //     //   "url": "",
  //     //   "perms": "",
  //     //   "type": 0,
  //     //   "icon": "el-icon-service",
  //     //   "orderNum": 2,
  //     //   "delFlag": 0,
  //     //   "parentName": null,
  //     //   "level": 0,
  //     //   "children": [{
  //     //     "id": 41,
  //     //     "createBy": "admin",
  //     //     "createTime": "2018-11-03T03:06:48.000+0000",
  //     //     "lastUpdateBy": "admin",
  //     //     "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
  //     //     "parentId": 44,
  //     //     "name": "注册中心",
  //     //     "url": "http://139.196.87.48:8500",
  //     //     "perms": "",
  //     //     "type": 1,
  //     //     "icon": " el-icon-view",
  //     //     "orderNum": 0,
  //     //     "delFlag": 0,
  //     //     "parentName": "服务治理",
  //     //     "level": 1,
  //     //     "children": []
  //     //   }]
  //     // }, {
  //     //   "id": 35,
  //     //   "createBy": null,
  //     //   "createTime": null,
  //     //   "lastUpdateBy": "admin",
  //     //   "lastUpdateTime": "2018-12-27T03:04:18.000+0000",
  //     //   "parentId": 0,
  //     //   "name": "接口文档",
  //     //   "url": "http://139.196.87.48:8001/swagger-ui.html",
  //     //   "perms": null,
  //     //   "type": 1,
  //     //   "icon": "el-icon-document",
  //     //   "orderNum": 3,
  //     //   "delFlag": 0,
  //     //   "parentName": null,
  //     //   "level": 0,
  //     //   "children": []
  //     // }, {
  //     //   "id": 42,
  //     //   "createBy": "admin",
  //     //   "createTime": "2018-11-15T06:39:30.000+0000",
  //     //   "lastUpdateBy": "admin",
  //     //   "lastUpdateTime": "2018-11-15T06:56:18.000+0000",
  //     //   "parentId": 0,
  //     //   "name": "代码生成",
  //     //   "url": "/generator/generator",
  //     //   "perms": "",
  //     //   "type": 1,
  //     //   "icon": "el-icon-star-on",
  //     //   "orderNum": 5,
  //     //   "delFlag": 0,
  //     //   "parentName": null,
  //     //   "level": 0,
  //     //   "children": []
  //     // }, {
  //     //   "id": 28,
  //     //   "createBy": null,
  //     //   "createTime": null,
  //     //   "lastUpdateBy": "admin",
  //     //   "lastUpdateTime": "2018-11-15T06:39:43.000+0000",
  //     //   "parentId": 0,
  //     //   "name": "使用案例",
  //     //   "url": null,
  //     //   "perms": null,
  //     //   "type": 0,
  //     //   "icon": "el-icon-picture-outline",
  //     //   "orderNum": 6,
  //     //   "delFlag": 0,
  //     //   "parentName": null,
  //     //   "level": 0,
  //     //   "children": [{
  //     //     "id": 29,
  //     //     "createBy": null,
  //     //     "createTime": null,
  //     //     "lastUpdateBy": null,
  //     //     "lastUpdateTime": null,
  //     //     "parentId": 28,
  //     //     "name": "国际化",
  //     //     "url": "/demo/i18n",
  //     //     "perms": null,
  //     //     "type": 1,
  //     //     "icon": "el-icon-edit",
  //     //     "orderNum": 1,
  //     //     "delFlag": 0,
  //     //     "parentName": "使用案例",
  //     //     "level": 1,
  //     //     "children": []
  //     //   }, {
  //     //     "id": 30,
  //     //     "createBy": null,
  //     //     "createTime": null,
  //     //     "lastUpdateBy": null,
  //     //     "lastUpdateTime": null,
  //     //     "parentId": 28,
  //     //     "name": "换皮肤",
  //     //     "url": "/demo/theme",
  //     //     "perms": null,
  //     //     "type": 1,
  //     //     "icon": "el-icon-picture",
  //     //     "orderNum": 2,
  //     //     "delFlag": 0,
  //     //     "parentName": "使用案例",
  //     //     "level": 1,
  //     //     "children": []
  //     //   }]
  //     // }
  //   ]
  // }

  return {
    url: 'menu/findNavTree',
    type: 'get',
    data: navTreeData
  }
}

// 获取菜单树
export function findMenuTree() {
  const menuTreeData = {
    "code": 200,
    "msg": null,
    "data": [{
      "id": 1,
      "createBy": null,
      "createTime": null,
      "lastUpdateBy": null,
      "lastUpdateTime": null,
      "parentId": 0,
      "name": "系统管理",
      "url": null,
      "perms": null,
      "type": 0,
      "icon": "el-icon-setting",
      "orderNum": 0,
      "delFlag": 0,
      "parentName": null,
      "level": 0,
      "children": [{
        "id": 2,
        "createBy": null,
        "createTime": null,
        "lastUpdateBy": null,
        "lastUpdateTime": null,
        "parentId": 1,
        "name": "用户管理",
        "url": "/sys/user",
        "perms": null,
        "type": 1,
        "icon": "el-icon-service",
        "orderNum": 1,
        "delFlag": 0,
        "parentName": "系统管理",
        "level": 1,
        "children": [{
          "id": 9,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 2,
          "name": "查看",
          "url": null,
          "perms": "sys:user:view",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "用户管理",
          "level": 2,
          "children": []
        }, {
          "id": 10,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 2,
          "name": "新增",
          "url": null,
          "perms": "sys:user:add",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "用户管理",
          "level": 2,
          "children": []
        }, {
          "id": 11,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 2,
          "name": "修改",
          "url": null,
          "perms": "sys:user:edit",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "用户管理",
          "level": 2,
          "children": []
        }, {
          "id": 12,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 2,
          "name": "删除",
          "url": null,
          "perms": "sys:user:delete",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "用户管理",
          "level": 2,
          "children": []
        }]
      }, {
        "id": 3,
        "createBy": null,
        "createTime": null,
        "lastUpdateBy": null,
        "lastUpdateTime": null,
        "parentId": 1,
        "name": "机构管理",
        "url": "/sys/dept",
        "perms": null,
        "type": 1,
        "icon": "el-icon-news",
        "orderNum": 2,
        "delFlag": 0,
        "parentName": "系统管理",
        "level": 1,
        "children": [{
          "id": 13,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 3,
          "name": "查看",
          "url": null,
          "perms": "sys:dept:view",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "机构管理",
          "level": 2,
          "children": []
        }, {
          "id": 14,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 3,
          "name": "新增",
          "url": null,
          "perms": "sys:dept:add",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "机构管理",
          "level": 2,
          "children": []
        }, {
          "id": 15,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 3,
          "name": "修改",
          "url": null,
          "perms": "sys:dept:edit",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "机构管理",
          "level": 2,
          "children": []
        }, {
          "id": 16,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 3,
          "name": "删除",
          "url": null,
          "perms": "sys:dept:delete",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "机构管理",
          "level": 2,
          "children": []
        }]
      }, {
        "id": 4,
        "createBy": null,
        "createTime": null,
        "lastUpdateBy": null,
        "lastUpdateTime": null,
        "parentId": 1,
        "name": "角色管理",
        "url": "/sys/role",
        "perms": null,
        "type": 1,
        "icon": "el-icon-view",
        "orderNum": 4,
        "delFlag": 0,
        "parentName": "系统管理",
        "level": 1,
        "children": [{
          "id": 17,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 4,
          "name": "查看",
          "url": null,
          "perms": "sys:role:view",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "角色管理",
          "level": 2,
          "children": []
        }, {
          "id": 18,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 4,
          "name": "新增",
          "url": null,
          "perms": "sys:role:add",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "角色管理",
          "level": 2,
          "children": []
        }, {
          "id": 19,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 4,
          "name": "修改",
          "url": null,
          "perms": "sys:role:edit",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "角色管理",
          "level": 2,
          "children": []
        }, {
          "id": 20,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 4,
          "name": "删除",
          "url": null,
          "perms": "sys:role:delete",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "角色管理",
          "level": 2,
          "children": []
        }]
      }, {
        "id": 5,
        "createBy": null,
        "createTime": null,
        "lastUpdateBy": null,
        "lastUpdateTime": null,
        "parentId": 1,
        "name": "菜单管理",
        "url": "/sys/menu",
        "perms": null,
        "type": 1,
        "icon": "el-icon-menu",
        "orderNum": 5,
        "delFlag": 0,
        "parentName": "系统管理",
        "level": 1,
        "children": [{
          "id": 21,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 5,
          "name": "查看",
          "url": null,
          "perms": "sys:menu:view",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "菜单管理",
          "level": 2,
          "children": []
        }, {
          "id": 22,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 5,
          "name": "新增",
          "url": null,
          "perms": "sys:menu:add",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "菜单管理",
          "level": 2,
          "children": []
        }, {
          "id": 23,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 5,
          "name": "修改",
          "url": null,
          "perms": "sys:menu:edit",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "菜单管理",
          "level": 2,
          "children": []
        }, {
          "id": 24,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 5,
          "name": "删除",
          "url": null,
          "perms": "sys:menu:delete",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "菜单管理",
          "level": 2,
          "children": []
        }]
      }, {
        "id": 7,
        "createBy": null,
        "createTime": null,
        "lastUpdateBy": null,
        "lastUpdateTime": null,
        "parentId": 1,
        "name": "字典管理",
        "url": "/sys/dict",
        "perms": null,
        "type": 1,
        "icon": "el-icon-edit-outline",
        "orderNum": 7,
        "delFlag": 0,
        "parentName": "系统管理",
        "level": 1,
        "children": [{
          "id": 31,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 7,
          "name": "查看",
          "url": null,
          "perms": "sys:dict:view",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "字典管理",
          "level": 2,
          "children": []
        }, {
          "id": 32,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 7,
          "name": "新增",
          "url": null,
          "perms": "sys:dict:add",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "字典管理",
          "level": 2,
          "children": []
        }, {
          "id": 33,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 7,
          "name": "修改",
          "url": null,
          "perms": "sys:dict:edit",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "字典管理",
          "level": 2,
          "children": []
        }, {
          "id": 34,
          "createBy": null,
          "createTime": null,
          "lastUpdateBy": null,
          "lastUpdateTime": null,
          "parentId": 7,
          "name": "删除",
          "url": null,
          "perms": "sys:dict:delete",
          "type": 2,
          "icon": null,
          "orderNum": 0,
          "delFlag": 0,
          "parentName": "字典管理",
          "level": 2,
          "children": []
        }]
      }, {
        "id": 8,
        "createBy": null,
        "createTime": null,
        "lastUpdateBy": "admin",
        "lastUpdateTime": "2018-09-23T11:32:28.000+0000",
        "parentId": 1,
        "name": "系统日志",
        "url": "/sys/log",
        "perms": "sys:log:view",
        "type": 1,
        "icon": "el-icon-info",
        "orderNum": 8,
        "delFlag": 0,
        "parentName": "系统管理",
        "level": 1,
        "children": []
      }]
    }, {
      "id": 43,
      "createBy": "admin",
      "createTime": "2018-12-27T02:57:29.000+0000",
      "lastUpdateBy": "admin",
      "lastUpdateTime": "2018-12-27T03:02:26.000+0000",
      "parentId": 0,
      "name": "系统监控",
      "url": "",
      "perms": "",
      "type": 0,
      "icon": "el-icon-info",
      "orderNum": 1,
      "delFlag": 0,
      "parentName": null,
      "level": 0,
      "children": [{
        "id": 6,
        "createBy": null,
        "createTime": null,
        "lastUpdateBy": "admin",
        "lastUpdateTime": "2018-12-27T03:03:45.000+0000",
        "parentId": 43,
        "name": "数据监控",
        "url": "http://139.196.87.48:8001/druid/login.html",
        "perms": null,
        "type": 1,
        "icon": "el-icon-warning",
        "orderNum": 0,
        "delFlag": 0,
        "parentName": "系统监控",
        "level": 1,
        "children": []
      }, {
        "id": 38,
        "createBy": "admin",
        "createTime": "2018-11-02T12:02:15.000+0000",
        "lastUpdateBy": "admin",
        "lastUpdateTime": "2018-12-27T03:03:53.000+0000",
        "parentId": 43,
        "name": "服务监控",
        "url": "http://139.196.87.48:8000/",
        "perms": "",
        "type": 1,
        "icon": "el-icon-view",
        "orderNum": 1,
        "delFlag": 0,
        "parentName": "系统监控",
        "level": 1,
        "children": []
      }]
    }, {
      "id": 44,
      "createBy": "admin",
      "createTime": "2018-12-27T03:05:48.000+0000",
      "lastUpdateBy": "admin",
      "lastUpdateTime": "2018-12-27T03:06:39.000+0000",
      "parentId": 0,
      "name": "服务治理",
      "url": "",
      "perms": "",
      "type": 0,
      "icon": "el-icon-service",
      "orderNum": 2,
      "delFlag": 0,
      "parentName": null,
      "level": 0,
      "children": [{
        "id": 41,
        "createBy": "admin",
        "createTime": "2018-11-03T03:06:48.000+0000",
        "lastUpdateBy": "admin",
        "lastUpdateTime": "2018-12-27T03:08:11.000+0000",
        "parentId": 44,
        "name": "注册中心",
        "url": "http://139.196.87.48:8500",
        "perms": "",
        "type": 1,
        "icon": " el-icon-view",
        "orderNum": 0,
        "delFlag": 0,
        "parentName": "服务治理",
        "level": 1,
        "children": []
      }]
    }, {
      "id": 35,
      "createBy": null,
      "createTime": null,
      "lastUpdateBy": "admin",
      "lastUpdateTime": "2018-12-27T03:04:18.000+0000",
      "parentId": 0,
      "name": "接口文档",
      "url": "http://139.196.87.48:8001/swagger-ui.html",
      "perms": null,
      "type": 1,
      "icon": "el-icon-document",
      "orderNum": 3,
      "delFlag": 0,
      "parentName": null,
      "level": 0,
      "children": []
    }, {
      "id": 42,
      "createBy": "admin",
      "createTime": "2018-11-15T06:39:30.000+0000",
      "lastUpdateBy": "admin",
      "lastUpdateTime": "2018-11-15T06:56:18.000+0000",
      "parentId": 0,
      "name": "代码生成",
      "url": "/generator/generator",
      "perms": "",
      "type": 1,
      "icon": "el-icon-star-on",
      "orderNum": 5,
      "delFlag": 0,
      "parentName": null,
      "level": 0,
      "children": []
    }, {
      "id": 28,
      "createBy": null,
      "createTime": null,
      "lastUpdateBy": "admin",
      "lastUpdateTime": "2018-11-15T06:39:43.000+0000",
      "parentId": 0,
      "name": "使用案例",
      "url": null,
      "perms": null,
      "type": 0,
      "icon": "el-icon-picture-outline",
      "orderNum": 6,
      "delFlag": 0,
      "parentName": null,
      "level": 0,
      "children": [{
        "id": 29,
        "createBy": null,
        "createTime": null,
        "lastUpdateBy": null,
        "lastUpdateTime": null,
        "parentId": 28,
        "name": "国际化",
        "url": "/demo/i18n",
        "perms": null,
        "type": 1,
        "icon": "el-icon-edit",
        "orderNum": 1,
        "delFlag": 0,
        "parentName": "使用案例",
        "level": 1,
        "children": []
      }, {
        "id": 30,
        "createBy": null,
        "createTime": null,
        "lastUpdateBy": null,
        "lastUpdateTime": null,
        "parentId": 28,
        "name": "换皮肤",
        "url": "/demo/theme",
        "perms": null,
        "type": 1,
        "icon": "el-icon-picture",
        "orderNum": 2,
        "delFlag": 0,
        "parentName": "使用案例",
        "level": 1,
        "children": []
      }]
    }]
  }
  return {
    url: 'menu/findMenuTree',
    type: 'get',
    data: menuTreeData
  }
}

export function setParentName(data) {
  if (data == null) {
    return
  }
  let len = data.length
  for (let i = 0; i < len; i++) {
    let menu = data[i]
    menu.parentName = 'menu' + menu.parentId
    if (menu.children != null) {
      setParentName(menu.children)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mock/modules/menu.js